import { ACTIONS } from '../actions/user'

import { Order } from '../../interfaces/common/contract'
import { User } from '../../typings/base'
import { ssoLogoutRedirectUrl } from '../../utils/constants'

export interface UserReducerState {
  loading: boolean
  /** False until initial session restore (getUser or explicit skip) completes. */
  sessionChecked: boolean
  loginInProgress: boolean
  cardUpdated?: boolean
  userVerified?: boolean
  email?: any
  user?: User
  isLoggedIn?: boolean
  orders?: Order[]
  order?: Order
  /** Commande affichée sur la page de confirmation (récupérée par token + email). */
  confirmationOrder?: Order
  cards?: any
  balance?: any
  ghostUser?: any
  error?: any
}
const requiresSsoSessionCheck = Boolean(ssoLogoutRedirectUrl)

export const initialProductsState: UserReducerState = {
  loading: requiresSsoSessionCheck,
  sessionChecked: !requiresSsoSessionCheck,
  loginInProgress: false,
  isLoggedIn: false,
}

const userReducer = (
  state = initialProductsState,
  action
): UserReducerState => {
  switch (action.type) {
    case ACTIONS.SAVE_USER_REQUEST:
    case ACTIONS.REGISTER_USER_REQUEST:
    case ACTIONS.GET_USER_ORDERS_REQUEST:
    case ACTIONS.GET_USER_ORDER_BY_TOKEN_REQUEST:
    case ACTIONS.GET_CONFIRMATION_ORDER_REQUEST:
    case ACTIONS.PUT_USER_REQUEST:
    case ACTIONS.PUT_USER_PASSWORD_REQUEST:
    case ACTIONS.FORGET_PASSWORD_REQUEST:
    case ACTIONS.GET_USER_REQUEST:
    case ACTIONS.VERIFY_USER_REQUEST:
    case ACTIONS.RESET_PASSWORD_REQUEST:
    case ACTIONS.PUT_USER_ORDER_REQUEST:
      return { ...state, loading: true }
    case ACTIONS.LOGIN_USER_REQUEST:
      return { ...state, loginInProgress: true }
    case ACTIONS.GET_USER_CARDS_REQUEST:
    case ACTIONS.POST_USER_CARD_REQUEST:
      return { ...state, loading: true, cardUpdated: false }
    case ACTIONS.VERIFY_USER_SUCCESS:
      return { ...state, loading: false, userVerified: true }
    case ACTIONS.SAVE_USER_SUCCESS:
      return { ...state, loading: false, email: action.email }
    case ACTIONS.REGISTER_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        sessionChecked: true,
        user: action.token,
        isLoggedIn: true,
      }
    case ACTIONS.LOGIN_USER_SUCCESS:
      return {
        ...state,
        loginInProgress: false,
        sessionChecked: true,
        user: action.user,
        isLoggedIn: !!action.user,
      }
    case ACTIONS.PUT_USER_SUCCESS:
    case ACTIONS.GET_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        sessionChecked: true,
        user: action.user,
        isLoggedIn: !!action.user,
      }
    case ACTIONS.FINISH_SESSION_CHECK:
      return { ...state, loading: false, sessionChecked: true }
    case ACTIONS.LOGOUT_USER_SUCCESS:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
        orders: undefined,
        sessionChecked: true,
      }
    case ACTIONS.GET_USER_ORDERS_SUCCESS:
      return { ...state, loading: false, orders: action.orders }
    case ACTIONS.GET_USER_ORDER_BY_TOKEN_SUCCESS:
      return { ...state, loading: false, order: action.orders }
    case ACTIONS.GET_CONFIRMATION_ORDER_SUCCESS:
      return { ...state, loading: false, confirmationOrder: action.order }
    case ACTIONS.GET_USER_CARDS_SUCCESS:
      return {
        ...state,
        loading: false,
        cardUpdated: false,
        cards: action.cards,
      }
    case ACTIONS.GET_USER_BALANCE_SUCCESS:
      return {
        ...state,
        balance: action.balance,
      }
    case ACTIONS.POST_USER_CARD_SUCCESS:
      return {
        ...state,
        loading: false,
        cardUpdated: true,
        cards: action.cards,
      }
    case ACTIONS.SAVE_GHOST_USER:
      return { ...state, loading: false, ghostUser: action.ghostUserData }
    case ACTIONS.PUT_USER_PASSWORD_SUCCESS:
    case ACTIONS.RESET_PASSWORD_SUCCESS:
    case ACTIONS.FORGET_PASSWORD_SUCCESS:
    case ACTIONS.PUT_USER_ORDER_SUCCESS:
    case ACTIONS.LOGIN_USER_FAILURE:
    case ACTIONS.REGISTER_USER_FAILURE:
    case ACTIONS.PUT_USER_FAILURE:
    case ACTIONS.GET_USER_ORDERS_FAILURE:
    case ACTIONS.GET_USER_ORDER_BY_TOKEN_FAILURE:
    case ACTIONS.GET_CONFIRMATION_ORDER_FAILURE:
    case ACTIONS.FORGET_PASSWORD_FAILURE:
    case ACTIONS.GET_USER_FAILURE:
      return {
        ...state,
        loading: false,
        sessionChecked: true,
        error: action.err,
      }
    case ACTIONS.RESET_PASSWORD_FAILURE:
    case ACTIONS.PUT_USER_ORDER_FAILURE:
    case ACTIONS.GET_USER_CARDS_FAILURE:
    case ACTIONS.POST_USER_CARD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.err,
      }
    case ACTIONS.VERIFY_USER_FAILURE:
      return {
        ...state,
        loading: false,
        userVerified: false,
        error: action.err,
      }
    case ACTIONS.DELETE_USER_SUCCESS:
    case ACTIONS.DELETE_GHOST_USER:
      return {
        loading: false,
        loginInProgress: false,
        sessionChecked: true,
        isLoggedIn: false,
      }
    default:
      return state
  }
}
export default userReducer
